import {RECEIVE_MANAGERS, REQUEST_MANAGERS} from "../actionTypes";
import fetch from "cross-fetch";
import {API_ROOT} from "../../config";
import {authenticatedPost} from "../utilities";

function requestManagers(business) {
  return {
    type: REQUEST_MANAGERS,
    business: business
  };
}

export function receiveManagers(managers) {
  return {
    type: RECEIVE_MANAGERS,
    items: managers
  };
}

export function fetchManagers(business) {
  return dispatch => {
    dispatch(requestManagers(business));
    return fetch(API_ROOT + '/businesses/' + business.id + '/managers/')
      .then(response => response.json())
      .then(json => dispatch(receiveManagers(json)));
  }
}

export function fetchManagersIfNeeded(business) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.managers.items) {
      return dispatch(fetchManagers(business));
    }
  }
}

export function createManager({name, phone}) {
  return (dispatch, getState) => {
    const state = getState();

    return authenticatedPost(API_ROOT + '/managers/', {
      name: name,
      phone: phone,
      business: state.business.item.id,
    }, state).then(response => {
      if (response.status === 201) {
        return response.json().then(manager => {
          dispatch(receiveManagers([manager]));
        });
      }
    }, error => console.log(error));
  };
}


// WEBPACK FOOTER //
// ./src/state/actions/managers.js